import { render } from "./dialogSearchProduct.vue?vue&type=template&id=09ecb2d4&scoped=true"
import script from "./dialogSearchProduct.vue?vue&type=script&lang=js"
export * from "./dialogSearchProduct.vue?vue&type=script&lang=js"

import "./dialogSearchProduct.vue?vue&type=style&index=0&id=09ecb2d4&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ecb2d4"]])

export default __exports__